"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring = __importStar(require("querystring"));
var URL = __importStar(require("url"));
var path_to_regexp_1 = __importDefault(require("path-to-regexp"));
function createPath(urlTemplate) {
    if (!urlTemplate) {
        throw new Error("URL template is not defined.");
    }
    return new UrlPathImpl(urlTemplate);
}
exports.createPath = createPath;
var UrlPathImpl = /** @class */ (function () {
    function UrlPathImpl(urlTemplate) {
        if (urlTemplate.endsWith("/") && urlTemplate !== "/") {
            urlTemplate = urlTemplate.replace(/\/$/, "");
        }
        this.urlTemplate = urlTemplate;
    }
    Object.defineProperty(UrlPathImpl.prototype, "paramType", {
        get: function () {
            throw new Error("Use this property in Typescript typeof operator only");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UrlPathImpl.prototype, "queryType", {
        get: function () {
            throw new Error("Use this property in Typescript typeof operator only");
        },
        enumerable: true,
        configurable: true
    });
    UrlPathImpl.prototype.createChildPath = function (urlTemplate) {
        var parentTemplate = this.urlTemplate.replace(/\/$/g, "");
        var childTemplate = urlTemplate || "";
        return new UrlPathImpl(parentTemplate + "/" + childTemplate);
    };
    UrlPathImpl.prototype.match = function (url, exact) {
        var location = this.normalizeUrl(url);
        //
        var paramNames = [];
        var regexpTemplate = exact
            ? path_to_regexp_1.default(this.urlTemplate, paramNames)
            : path_to_regexp_1.default(this.urlTemplate, paramNames, { end: false });
        var result = regexpTemplate.exec(location.pathname);
        var noMatch = {
            isMatched: false,
            asMatched: function () {
                throw Error("The URL is not matched");
            }
        };
        if (!result || result.length < paramNames.length + 1) {
            return noMatch;
        }
        var matches = result.slice(1);
        if (matches.length !== paramNames.length) {
            return noMatch;
        }
        var params = matches.reduce(function (result, value, index) {
            result[paramNames[index].name] = value;
            return result;
        }, {});
        var query = undefined;
        if (location.search) {
            var searchString = location.search.startsWith("?")
                ? location.search.substring(location.search.indexOf("?") + 1)
                : location.search;
            query = querystring.parse(searchString);
        }
        return {
            isMatched: true,
            params: params,
            query: query,
            asMatched: function () {
                return this;
            }
        };
    };
    UrlPathImpl.prototype.format = function (params, query) {
        params = params || {};
        var qs = querystring.stringify(query);
        qs = qs ? "?" + qs : "";
        var toPath = path_to_regexp_1.default.compile(this.urlTemplate);
        var result = toPath(params);
        return result + qs;
    };
    /**
     * Parses URL and constructs new URL with
     * partially updated parameters and query string.
     *
     * If given URL doesn't match current UrlPath instance, method returns undefined.
     */
    UrlPathImpl.prototype.replace = function (url, params, query) {
        var match = this.match(url, true);
        if (!match.isMatched) {
            return undefined;
        }
        return this.format(this.overrideProps(match.params, params), this.overrideProps(match.query, query));
    };
    UrlPathImpl.prototype.normalizeUrl = function (url) {
        if (typeof url === "string") {
            var parsedUrl = URL.parse(url);
            return {
                pathname: parsedUrl.pathname || "/",
                search: parsedUrl.search
            };
        }
        if (typeof url === "object") {
            return {
                pathname: url.pathname,
                search: !url.search || url.search.indexOf("?") !== 0 ? url.search : url.search.substring(1)
            };
        }
        return {
            pathname: ""
        };
    };
    UrlPathImpl.prototype.overrideProps = function (existing, override) {
        var e_1, _a;
        var result = {};
        try {
            for (var _b = __values([existing || {}, override || {}]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var obj = _c.value;
                for (var prop in obj) {
                    var value = obj[prop];
                    if (value === null || value === undefined || value === "") {
                        delete result[prop];
                    }
                    else {
                        result[prop] = value;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    return UrlPathImpl;
}());
//# sourceMappingURL=createPath.js.map